import FormInvoiceCreate from './FormInvoiceCreate';
import FormInvoiceUpdate from './FormInvoiceUpdate';
import FormInvoiceFilter from './FormInvoiceFilter';
import FormInvoicePrint from './FormInvoicePrint';
import FormInvoiceDelete from './FormInvoiceDelete';

export default Object.assign(
  {},
  {
    Create: FormInvoiceCreate,
    Update: FormInvoiceUpdate,
    Filter: FormInvoiceFilter,
    Print: FormInvoicePrint,
    Delete: FormInvoiceDelete,
  },
);
